/*! snusify-pdp-redesign — behaviour for the redesigned product hero.
    Three jobs, all additive to tso-product-hero-velo's own script:
      1. the pack total is mirrored inside the Add to cart button
      2. the flavour-profile rings light up one segment at a time
      3. the image plate matches the buy panel's bottom edge
    The flavour chips and thumbnails are plain links, so switching flavour is
    a normal navigation and needs no JS. */
(function () {
  var root = document.querySelector('.nik-pdp');
  if (!root) return;

  /* ---- 1. Pack total inside the CTA ------------------------------------ */
  (function () {
    var out = root.querySelector('#sn-atc-price');
    var was = root.querySelector('#sn-atc-was');
    var tiers = root.querySelector('#nik-tiers');
    if (!out) return;

    /* What this pack would have billed without the volume discount. The two
       picker branches carry it differently: a variant pack puts it on the tier
       as data-compare-str, the quantity ladder prints it in the row as
       .nik-tier-was (the ladder has no attribute for it). A tier with neither
       — the single can, or a deal-of-the-week product, which the Rapi bundle
       excludes — has no saving to show, and the element stays hidden rather
       than advertising one. */
    function wasStr(tier) {
      if (tier.getAttribute('data-compare-str')) return tier.getAttribute('data-compare-str');
      var s = tier.querySelector('.nik-tier-was');
      return s ? s.textContent.trim() : '';
    }

    function sync() {
      var sel = root.querySelector('.nik-tier.selected');
      var total = sel && (sel.getAttribute('data-total-str') || sel.getAttribute('data-price-str'));
      if (total) out.textContent = total;
      if (was && sel) {
        var w = wasStr(sel);
        was.textContent = w;
        was.hidden = !w;
      }
    }
    sync();
    if (tiers) {
      tiers.addEventListener('click', function () { window.setTimeout(sync, 0); });
      new MutationObserver(sync).observe(tiers, {
        subtree: true, attributes: true, attributeFilter: ['class', 'aria-checked']
      });
    }
  })();

  /* ---- 2. Staggered ring reveal ---------------------------------------- */
  (function () {
    var rings = root.querySelectorAll('.sn-profile__item');
    if (!rings.length) return;
    /* A CSS transition-delay never fired here: the class flips happen in one
       task, so the browser coalesced them. Timers are explicit and reliable. */
    var timers = [];
    function play() {
      timers.forEach(window.clearTimeout);
      timers = [];
      var values = [];
      rings.forEach(function (item) {
        var segs = item.querySelectorAll('.sn-seg');
        values.push(item.querySelectorAll('.sn-seg.is-on').length);
        segs.forEach(function (seg) {
          seg.classList.remove('is-on');
          seg.classList.add('is-off');
        });
      });
      rings.forEach(function (item, i) {
        item.querySelectorAll('.sn-seg').forEach(function (seg, n) {
          if (n >= values[i]) return;
          timers.push(window.setTimeout(function () {
            seg.classList.remove('is-off');
            seg.classList.add('is-on');
          }, 100 + i * 200 + n * 60));
        });
      });
    }
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    play();
  })();

  /* ---- 3. Image plate ends level with the buy panel -------------------- */
  (function () {
    var plate = root.querySelector('.nik-gallery-main');
    var panel = root.querySelector('.sn-buypanel');
    if (!plate || !panel) return;
    var FOLD_GAP = 30;    /* how far above the fold the pair may stop */
    var MAX_EXTRA = 360;  /* the most padding the panel may be padded out by */
    var basePad = null;   /* the panel's own bottom padding, read from the CSS */
    var extra = 0;        /* how much of the panel's padding we added */

    /* Only write when the value actually changes. The observer below watches
       the very element these writes resize, so an unconditional write would
       wake it again on every pass; skipping the no-op write lets it settle. */
    function set(el, prop, value) {
      if (el.style[prop] !== value) el.style[prop] = value;
    }

    /* Layout position, walking offsetParents. Both columns are position:sticky,
       so a getBoundingClientRect() taken while the page is scrolled reports the
       shifted position and the plate and the panel stop being comparable;
       offsetTop is the unshifted position. */
    function layoutTop(el) {
      var y = 0;
      for (var n = el; n; n = n.offsetParent) y += n.offsetTop;
      return y;
    }

    function fit() {
      /* The plate's height comes from its 1/1 aspect ratio, the panel's from
         its content, so the two blocks never line up on their own. Growing the
         plate only moves things inside the left column, so there is no
         feedback loop. */
      if (window.innerWidth < 990) {
        set(panel, 'paddingBottom', '');
        set(plate, 'height', '');
        extra = 0;
        return;
      }
      if (basePad === null && !extra) {
        basePad = parseFloat(window.getComputedStyle(panel).paddingBottom) || 0;
      }
      var top = layoutTop(plate);
      var natural = layoutTop(panel) + panel.offsetHeight - extra;
      var target = Math.max(natural, window.innerHeight - FOLD_GAP);
      var want = Math.max(0, Math.min(Math.round(target - natural), MAX_EXTRA));
      if (want !== extra) {
        set(panel, 'paddingBottom', want ? basePad + want + 'px' : '');
        extra = want;
      }
      var h = natural + want - top;
      set(plate, 'height', h > 320 ? h + 'px' : '');
    }
    fit();
    window.addEventListener('resize', fit);
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(fit);
    document.addEventListener('shopify:section:load', fit);
    /* The panel's height is not final at load — web fonts settle, and the pack
       list changes it every time it opens and closes. This observer keeps the
       plate level with it through all of that. */
    if (window.ResizeObserver) new window.ResizeObserver(fit).observe(panel);
  })();
})();
